import {
  type RequestConfig,
  type ResponseConfig,
  type ResponseErrorConfig,
  type Client,
} from "@kubb/plugin-client/clients/axios"
import type { AxiosError } from "axios"

import { httpClient } from "~/backend/axios"

const axiosClient = async <TData, TError = unknown, TVariables = unknown>(
  config: RequestConfig<TVariables>
): Promise<ResponseConfig<TData>> => {
  const promise = httpClient
    .request<TVariables, ResponseConfig<TData>>({ ...config })
    .catch((e: AxiosError<TError>) => {
      throw e
    })

  return promise
}
export type { RequestConfig, ResponseConfig, ResponseErrorConfig, Client }
export default axiosClient
